/*
 * @Author: chenx
 * @Descripttion:
 * @Date: 2021-12-09 10:45:56
 * @LastEditors: chenx
 * @LastEditTime: 2022-01-07 15:02:29
 */
// 拍卖
import request from '@/http/zhaocai'
const zcUrl = process.env.VUE_APP_API // 招采

const tenderCommonApi = {
  // 直接竞价列表排序
  directBidSort: () => request.get(`${zcUrl}/ov1/bid/getBidSortSelect`),
  newDirectBidSort: () => request.get(`${zcUrl}/ov1/mechanicalLabor/bidSortSelectTab`),
  // 招标预告列表排序
  tenderNoticeSort: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getTenderSortSelect`),
  // 需求预告列表排序
  tenderPreNoticeSort: () => request.get(`${zcUrl}/ov1/tender/preNotice/getTenderPreNoticeSortSelect`),
  // 数据来源
  getDataSources: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getDataSources`),
  // 招标方式
  getBiddingMethod: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getBiddingMethod`),
  // 对应排序（招标大厅/招标公告）
  getTenderingSortSelectTab: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getTenderingSortSelectTab`),
  // 招标类型
  getTenderType: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderTypeSelectCustom`),
  // 招标类型树结构
  getTenderTypeTree: (data) => request.post(`${zcUrl}/ov1/typeDict/findChildrenTreeByParentNoAndBusinessScenario`, data),
  // 招采方式
  getTenderWay: (data) => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderWayByType/${data}`),
  // 市列表
  getCitys: (data) => request.get(`${zcUrl}/old/api/font/citys`, data),
  // 报名截止时间options
  getTenderTimeOptions: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderTimeSelect`),
  // 资格审查方式options
  getTenderWayOptions: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderTypeBidWaySelect`),
  // 招标方式options
  getTenderMethodOptions: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getBiddingMethod`),
  // 数据来源options
  getDataSourcesOptions: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getDataSources`),
  // 预算金额范围
  getMoneySelectOptions: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderMoneySelect`),
  // 招标状态
  getTenderState: () => request.get(`${zcUrl}/ov1/mechanicalLabor/tenderBidderSelect`),
  // 招标公告|招标大厅-招采方式-不限 列表排序
  getSortAll: () => request.get(`${zcUrl}/ov1/mechanicalLabor/getTenderingSortSelectTab`),
  // 招标预告列表排序
  getSortPrenotice: () => request.get(`${zcUrl}/ov1/tender/preNotice/getTenderPreNoticeSortSelect`),
  // 动态竞价列表排序
  getSortDysincBid: () => request.get(`${zcUrl}/ov1/mechanicalLabor/bidSortSelectTab`),
}
export default tenderCommonApi
